/**
 * Feedback and bug ticketing options shared across the service app.
 * Keep these aligned with the mobile app for consistent reporting.
 */
export const feedbackTypeOptions = [
  { label: "Issue", value: "bug" },
  { label: "Question / Other", value: "feedback" },
  { label: "Feature Request", value: "feature" },
];

/**
 * High-level areas where issues or feedback can occur.
 */
export const feedbackCategoryOptions = [
  { label: "Dispatch", value: "dispatch" },
  { label: "Scheduling", value: "scheduling" },
  { label: "Jobs", value: "jobs" },
  { label: "Inventory", value: "inventory" },
  { label: "Equipment", value: "equipment" },
  { label: "Billing", value: "billing" },
  { label: "Reporting", value: "reporting" },
  { label: "Notifications", value: "notifications" },
  { label: "Authentication", value: "authentication" },
  { label: "Settings", value: "settings" },
  { label: "Other", value: "other" },
];

/**
 * Ticket priority levels.
 */
export const feedbackPriorityOptions = [
  { label: "Low", value: "Low" },
  { label: "Medium", value: "Medium" },
  { label: "High", value: "High" },
  { label: "Critical", value: "Critical" },
];

/**
 * Impact levels to communicate business urgency.
 */
export const feedbackImpactOptions = [
  { label: "Minor inconvenience", value: "minor" },
  { label: "Workflow slowed", value: "moderate" },
  { label: "Work blocked", value: "blocked" },
  { label: "Safety or compliance risk", value: "risk" },
];

/**
 * Reproducibility options for bugs.
 */
export const feedbackReproOptions = [
  { label: "Every time", value: "always" },
  { label: "Often", value: "often" },
  { label: "Sometimes", value: "sometimes" },
  { label: "Rarely", value: "rarely" },
  { label: "Unable to reproduce", value: "unknown" },
];

/**
 * Environment options to help diagnose issues.
 */
export const feedbackEnvironmentOptions = [
  { label: "Production", value: "production" },
  { label: "Beta", value: "beta" },
  { label: "Alpha", value: "alpha" },
  { label: "Development", value: "development" },
];

/**
 * Ticket status options.
 */
export const feedbackStatusOptions = [
  { label: "New", value: "New" },
  { label: "In Review", value: "In Review" },
  { label: "In Progress", value: "In Progress" },
  { label: "Resolved", value: "Resolved" },
  { label: "Closed", value: "Closed" },
];
